import Action from "../interfaces/Action";
import ActionCreators from "../interfaces/ActionCreators";
import TabName from "../interfaces/TabName";
export const actions = {
  setVisibleTabName: "SET_VISIBLE_TAB_NAME",
  setAllCategories: "SET_ALL_CATEGORIES",
  setAllCoverages: "SET_ALL_COVERAGES",
  setAllUpdated: "SET_ALL_UPDATED",
  setSelectedPageId: "SET_SELECTED_PAGE_ID",
  deleteCoverage: "DELETE_COVERAGE",
  toggleModal: "TOGGLE_MODAL",
  toggleTooltip: "TOGGLE_TOOLTIP",
};

export const actionCreators: ActionCreators = {
  setVisibleTabName: (name: TabName): Action => {
    return { type: actions.setVisibleTabName, payload: name };
  },
  setAllCategories: (categories) => {
    return { type: actions.setAllCategories, payload: categories };
  },
  setAllCoverages: (coverages) => {
    return { type: actions.setAllCoverages, payload: coverages };
  },
  setSelectedPageId: (id) => {
    return { type: actions.setSelectedPageId, payload: id };
  },
  setAllUpdated: (items) => {
    return { type: actions.setAllUpdated, payload: items };
  },
  deleteCoverage: (id) => {
    return { type: actions.deleteCoverage, payload: id };
  },
  toggleModal: () => {
    return { type: actions.toggleModal, payload: null };
  },
  toggleTooltip: () => {
    return { type: actions.toggleTooltip, payload: null };
  },
};
